"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SVBTableOverview = props => {
  const {
    headers,
    columns,
    keys,
    data
  } = props;
  return /*#__PURE__*/_react.default.createElement("table", {
    className: "table font-family-roboto table-hover mw-detail-table"
  }, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
    className: "mw-detail-table-header"
  }, headers === null || headers === void 0 ? void 0 : headers.map((itm, ind) => {
    return /*#__PURE__*/_react.default.createElement("th", {
      key: ind,
      className: "col-6"
    }, itm);
  })), (keys === null || keys === void 0 ? void 0 : keys.length) === (columns === null || columns === void 0 ? void 0 : columns.length) && (columns === null || columns === void 0 ? void 0 : columns.map((item, ind) => {
    var _data$keys$ind;
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: ind,
      className: "mw-table-row"
    }, /*#__PURE__*/_react.default.createElement("th", null, item), /*#__PURE__*/_react.default.createElement("td", null, (_data$keys$ind = data[keys[ind]]) === null || _data$keys$ind === void 0 ? void 0 : _data$keys$ind.toString()));
  }))));
};
var _default = exports.default = SVBTableOverview;